<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品種グループ検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          v-permit.SHARP_PRODUCT_GROUP_SEARCH
          @click="search()"
          class="btn-search"
          >{{ $t("app.buttons.search") }}</v-btn
        >
        <v-btn v-permit.SHARP_PRODUCT_GROUP_NEW to="/M0270/New">{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          v-permit.SHARP_PRODUCT_GROUP_EDIT
          @click="edit()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          v-permit.SHARP_PRODUCT_GROUP_EDIT
          @click="remove()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.remove") }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <!-- <v-flex xs3>
              <v-text-field
                clearable
                label="品種グループCD"
                v-model="query.code"
              />
            </v-flex> -->
            <v-flex xs3>
              <v-text-field
                clearable
                label="品種グループ名"
                v-model="query.name"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="name"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td :key="head.text" v-for="head in headers">
            {{ props.item[head.value] }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [
        // { text: '品種グループCD', value: 'code', sortable: false },

        { text: "事業本部", value: "buName", sortable: false },
        { text: "BU", value: "businessUnitName", sortable: false },
        { text: "品種グループ名", value: "name", sortable: false },
      ],
    };
  },

  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      };
    },
    search() {
      this.pagination.page = 1;
      this.load();
    },
    load() {
      this.autoload = true;
      this.$storeParams();
      this.loading = true;
      this.$http
        .get("/product-groups", this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    edit() {
      this.$router.push({
        path: "M0270/edit",
        query: { name: this.selected[0].name },
      });
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http
          .delete(`/product-groups?name=${this.selected[0].name}`)
          .then(() => {
            this.load();
            this.$message("", this.$t("app.messages.removeSuccess"));
            this.selected = [];
          });
      });
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  mounted() {
    this.$loadParams();
  },
};
</script>
